import React from 'react';
import {NavLink, useLocation} from "react-router-dom";

const getNavStyle = (isActive: boolean) => {
  if (isActive) {
    return "text-accent px-6 2xl:px-11 py-7 font-semibold";
  }
  return "text-white hover:text-accent px-6 2xl:px-11 py-7 transition-colors duration-150 ease-in-out";
}

interface NavBarProps {
  responsiveMenu: boolean;
  scrollToTop: () => void;
  scrollToBottom: () => void;
}

const Navbar = ({ responsiveMenu, scrollToTop, scrollToBottom }: NavBarProps) => {
  const location = useLocation();
  const projectsSectionActive = location.pathname.startsWith('/projects');

  return (
  <ul className={`${responsiveMenu ? "translate-x-20" : "translate-x-96"} pt-20 xl:pt-0 space-y-12 xl:space-y-0 text-xl xl:text-sm h-screen xl:h-fit w-72 transition-transform bg-navy
      xl:w-fit xl:bg-transparent absolute right-0 top-0 translate-y-24 xl:translate-x-0 xl:translate-y-0 xl:static xl:flex
      mr-16 mt-3 justify-center items-center font-semibold uppercase tracking-wider`}>
    <li>
      <NavLink
        to="/"
        className={({ isActive }) => isActive ? "text-accent px-6 2xl:px-11 py-7 font-semibold" : "text-white hover:text-accent px-6 2xl:px-11 py-7 transition-colors duration-150 ease-in-out"}
        onClick={scrollToTop}>
        Home
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/about"
        className={({ isActive }) => getNavStyle(isActive)}
        onClick={scrollToTop}>
        About
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/services"
        className={({ isActive }) => getNavStyle(isActive)}
        onClick={scrollToTop}>
        Services
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/projects/construction"
        className={() => getNavStyle(projectsSectionActive)}
        onClick={scrollToTop}>
        Projects
      </NavLink>
    </li>
    <li>
      <button
        className="ml-10 py-3 px-5 xl:ml-4 bg-accent text-white rounded hover:bg-accent-dark transition-colors duration-150 ease-in-out text-sm"
        onClick={scrollToBottom}>
        Contact
      </button>
    </li>
  </ul>
  );
};

export default Navbar;
